import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import Home from "../screens/Home";
import Detail from "../screens/Detail";
import About from "../screens/AboutUs";
import BookCollection from "../screens/BookCollections";
import EnglishBooklet from "../screens/English/EnglishBooklet";
import AmharicBooklet from "../screens/Amharic/AmharicBooklet";
import OromifaBooklet from "../screens/Oromifa/OromifaBooklet";
import SidamignaBooklet from "../screens/Sidamigna/SidamignaBooklet";
import SomaliBooklet from "../screens/Somali/SomaliBooklet";
import AmharicPage from "../screens/Amharic/Amharic";
import EnglishPage from "../screens/English/English";
import OromifaPage from "../screens/Oromifa/Oromifa";
import SidamignaPage from "../screens/Sidamigna/Sidamigna";
import SomaliPage from "../screens/Somali/Somali";
const Stack = createStackNavigator();
const screenOptionStyle = {
  headerShown: false,
};

const HomeStackNavigator = () => {
  return (
    <Stack.Navigator screenOptions={screenOptionStyle}>
      <Stack.Screen name="Home" component={Home} />
      <Stack.Screen name="Detail" component={Detail} />
      <Stack.Screen name="About" component={About} />
      <Stack.Screen name="BookCollection" component={BookCollection} />
      <Stack.Screen name="EnglishBooklet" component={EnglishBooklet} />
      <Stack.Screen name="AmharicBooklet" component={AmharicBooklet} />
      <Stack.Screen name="OromifaBooklet" component={OromifaBooklet} />
      <Stack.Screen name="SidamignaBooklet" component={SidamignaBooklet} />
      <Stack.Screen name="SomaliBooklet" component={SomaliBooklet} />
      <Stack.Screen name="AmharicPage" component={AmharicPage} />
      <Stack.Screen name="EnglishPage" component={EnglishPage} />
      <Stack.Screen name="OromifaPage" component={OromifaPage} />
      <Stack.Screen name="SidamignaPage" component={SidamignaPage} />
      <Stack.Screen name="SomaliPage" component={SomaliPage} />
    </Stack.Navigator>
  );
};

export default HomeStackNavigator;
